<template>
  <div>
    <el-table class="table table__specifications" :data="specTableData" style="width: 100%">
      <el-table-column
        prop="attribute"
        label="Attribute">
      </el-table-column>
      <el-table-column
        prop="value"
        label="Value"
        :formatter="formatValue">
        <template slot-scope="scope">
          <div v-html="scope.row.value"></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import i18n from '@/configured/vue-i18n';

  export default {
    name: 'ProductSpecificationTable',
    props: {
      specification: {}
    },
    computed: {
      specTableData
    },
    methods: {
      formatValue
    }
  }

  //////////

  function specTableData() {
    let data = [];
    let displayAttributes = [
      // Propeller attributes
      "bladeCount",
      "availablePitches",
      "material",
      "alloy",
      "pvs",
      "rotation",
      "boatTypes",

      // Engine attributes
      "power",
      "maxRPM",
      "cylinders",
      "displacement",
      "boreStroke",
      "induction",
      "ignition",
      "fuelSystem",
      "alternator",
      "midsection",
      "starting",
      "gearcase",
      "gearShift",
      "controls",
      "steering",
      "mountingCenters",
      "protectionSystem",
      "recommendedOil",
      "oilCapacity",
      "fuelRequirements",
      "weight",
      "waterDrainSystem",
      "coolingSystem",
      "dimensions",
      "turbo",
      "emissions",
      "propulsion",
      "colors"
    ];

    displayAttributes.forEach(( item ) => {
      if (this.specification && this.specification[item]) {
        data.push({
          attribute: getTranslationForSpecKey(item),
          value    : parseSpecValue(this.specification[item])
        });
      }
    });

    if( this.specification && this.specification.customSpecifications ) {
      this.specification.customSpecifications.forEach((item) => {
        if(item.label || item.value) {
          data.push({
            attribute: item.label,
            value: item.value
          });
        }
      });
    }

    return data;
  }

  function parseSpecValue(value) {
    return value.toString().replace(/\r\n/gi, '<br>');
  }

  function formatValue(row, column, cellValue) {
    return cellValue;
  }

  function getTranslationForSpecKey( specKey ) {
    specKey = specKey.charAt(0).toUpperCase() + specKey.slice(1);
    return i18n.i18n.t(`productSpec${specKey}`);
  }
</script>

<style lang="scss" scoped>
</style>
